module.exports = __webpack_public_path__ + "static/img/preview-1.34f7b83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/preview-1.png
// module id = Gv0G
// module chunks = 35